import React, { PropsWithChildren } from 'react'
import { Link as rrLink } from 'react-router-dom'
import styled from 'styled-components'

import { useFeatureNavigation } from '../../utils/useFeatureNavigation'
interface IProps {
  to: string
}

export const Link: React.FC<PropsWithChildren<IProps>> = ({ to, children }) => {
  const { buildFeatureUrl } = useFeatureNavigation()
  return (
    <>
      <StyledLink to={buildFeatureUrl(to)}>{children}</StyledLink>
    </>
  )
}

const StyledLink = styled(rrLink)`
  text-decoration: none;

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`
